var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bind_account"},[_c(_vm.comName,{tag:"component",attrs:{"isLogin":false,"weixininfo":_vm.wxData.weixininfo},on:{"loginSuccess":_vm.loginSuccess,"changeWxBindCom":_vm.changeWxBindCom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }